// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3H8pJ","head":"Table_head__1bxKh","col":"Table_col__EAa_y"};